import React from 'react'
import { Search } from 'lucide-react'
import styles from './SearchBox.module.scss'

interface SearchBoxProps {
  value: string
  onChange: (value: string) => void
  placeholder?: string
}

export const SearchBox: React.FC<SearchBoxProps> = ({
  value, onChange, placeholder = 'Cerca articoli...',
}) => (
  <div className={styles.wrapper}>
    <Search size={18} className={styles.icon} />
    <input
      type="search"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      className={styles.input}
    />
  </div>
)
